import { Popover } from '@mantine/core';

export const PopoverOverride = Popover.extend({
  defaultProps: {
    // allows selecting of options in comboboxes in tests
    hideDetached: import.meta.env.MODE === 'test',
  },
});
